// Generated by Melange

import * as Buhta_landing__Api from "../../../core/Api.js";
import * as Buhta_landing__Content from "../../../core/Content.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__PreheaderCountrySelect from "./PreheaderCountrySelect.js";
import * as Buhta_landing__PreheaderLanguageSelect from "./PreheaderLanguageSelect.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Buhta_models__Cms from "../../../../../../packages/models/Cms.js";
import * as Buhta_models__Locale from "../../../../../../packages/models/Locale.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function Preheader(Props) {
  let theme = Props.theme;
  const preheaderBackground = theme === "dark" ? "bg-preheader" : "bg-gray-light-landing";
  const country = Buhta_landing__Route.getCountry(undefined);
  const intl = ReactIntl.useIntl();
  const match = Buhta_landing__Content.Context.useContent(undefined);
  const dispatchContent = match[1];
  const requisites = match[0].requisites;
  const language = Buhta_landing__Route.getLanguage(undefined);
  const languageStr = Buhta_models__Locale.toString(language);
  let requisite;
  try {
    requisite = Stdlib__List.find((function (r) {
      return r.country === Buhta_models__Locale.toCountryString(country);
    }), requisites);
  }
  catch (exn){
    requisite = Buhta_models__Cms.Requisites.$$default;
  }
  const phone = requisite.phone;
  const phoneLean = phone.replace(/\s/g, "");
  React.useEffect((function () {
    const __x = Buhta_landing__Api.requisites(languageStr);
    $$Promise.get(__x, (function (resp) {
      Buhta_landing__Api.handleResponse(resp, dispatchContent, undefined);
    }));
  }), [languageStr]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__PreheaderCountrySelect.make, {}),
              JsxRuntime.jsx(Buhta_landing__PreheaderLanguageSelect.make, {})
            ],
            className: "flex"
          }),
          JsxRuntime.jsxs("a", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-4",
                alt: "phone white",
                src: StaticAsset.src("/static/icons/phone-white.svg")
              }),
              JsxRuntime.jsx("span", {
                children: "" + phone,
                className: "text-white caption-preheader ml-1"
              })
            ],
            className: "lg:ml-4 flex",
            href: "tel:" + phoneLean
          })
        ],
        className: "px-6 lg:ml-4 flex justify-between lg:justify-start w-full lg:w-auto"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-4",
            alt: "question white",
            src: StaticAsset.src("/static/icons/question-white.svg")
          }),
          JsxRuntime.jsx("span", {
            children: Buhta_landing__I18n.trans(intl, "how_to_work_with_buhta"),
            className: "text-white caption-preheader ml-2"
          })
        ],
        className: "mr-10 hidden lg:flex"
      })
    ],
    className: "h-10 " + preheaderBackground + " flex items-center justify-between"
  });
}

const make = Preheader;

export {
  make,
}
/* Buhta_landing__Api Not a pure module */
